
import { Mixins, Component, Watch, Ref } from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import loading from "@/mixins/loading";
import Resize from "@/mixins/resize";
import ETable from '@/components/ETable.vue';
import { getHourList } from "@/api/twoHour";
import EditDialog from "./editDialog.vue";

@Component({ name: 'two-hour-components-TwoHourList', components: { ETable, EditDialog } })
export default class TwoHourList extends Mixins(tablePagination, loading, Resize) {

    columns = [
        { prop: "time", label: "时间区间", width: "120px" },
        { prop: "name", label: "时辰", width: "100px" },
        { prop: "matchViscera", label: "对应脏腑", width: "100px" },
        { prop: "goodTry", label: "宜", width: "120px" },
        { prop: "badTry", label: "忌", width: "120px" },
        { prop: "introduction", label: "通俗介绍" },
        { prop: "remark", label: "介绍说明" },
        { prop: "modifiedBy", label: "操作人", width: "100px" },
        { prop: "modifiedTime", label: "最后操作时间", width: "160px" },
        { prop: "action", label: "操作", width: "100px" },
    ];

    tableData = [];

    id = "";
    EditDialogVisible = false;

    mounted() {
        this.getData();
        this.windowResize();
    }

    getData() {
        this.showLoading();
        getHourList().then((res) => {
            this.tableData = res.data;
            this.tableData.forEach((item) => {
                const startTime = item.startTime.slice(0, 5);
                const endTime = item.endTime.slice(0, 5);
                item.time = startTime + " - " + endTime;
            });
        }).finally(() => {
            this.hideLoading();
        });
    }

    handleEdit(row) {
        this.id = row.id;
        this.EditDialogVisible = true;
    }

    editConfirm() {
        this.getData();
        this.EditDialogVisible = false;
    }
}
